"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Emitter_1 = __importDefault(require("licia/Emitter"));
var _1 = __importDefault(require("licia/$"));
var h_1 = __importDefault(require("licia/h"));
var each_1 = __importDefault(require("licia/each"));
var isNull_1 = __importDefault(require("licia/isNull"));
var isArr_1 = __importDefault(require("licia/isArr"));
var map_1 = __importDefault(require("licia/map"));
var keys_1 = __importDefault(require("licia/keys"));
var contain_1 = __importDefault(require("licia/contain"));
var has_1 = __importDefault(require("licia/has"));
var trim_1 = __importDefault(require("licia/trim"));
var toStr_1 = __importDefault(require("licia/toStr"));
require("./style.scss");
require("./icon.css");
var classPrefix = 'luna-json-editor-';
module.exports = (function (_super) {
    __extends(JsonEditor, _super);
    function JsonEditor(container, _a) {
        var _b = _a === void 0 ? {} : _a, name = _b.name, _c = _b.value, value = _c === void 0 ? null : _c, _d = _b.showName, showName = _d === void 0 ? true : _d, _e = _b.nameEditable, nameEditable = _e === void 0 ? true : _e, _f = _b.valueEditable, valueEditable = _f === void 0 ? true : _f, _g = _b.parent, parent = _g === void 0 ? null : _g, _h = _b.enableDelete, enableDelete = _h === void 0 ? true : _h, _j = _b.enableInsert, enableInsert = _j === void 0 ? true : _j;
        var _this = _super.call(this) || this;
        _this.type = 'unknown';
        _this.children = [];
        _this.parent = null;
        _this.expanded = false;
        _this.edittingName = false;
        _this.edittingValue = false;
        _this.nameEditable = true;
        _this.valueEditable = true;
        _this.enableInsert = true;
        _this.enableDelete = true;
        _this.collapse = function (recursive) {
            if (recursive) {
                each_1.default(_this.children, function (child) { return child.collapse(true); });
            }
            _this.expanded = false;
            _this.$children.hide();
            _this.$toggle.addClass(classPrefix + "expand");
            _this.$toggle.rmClass(classPrefix + "collapse");
            _this.$container.addClass(classPrefix + "collapsed");
            _this.$container.rmClass(classPrefix + "expanded");
        };
        _this.expand = function (recursive) {
            var _a = _this, type = _a.type, value = _a.value, children = _a.children;
            var _keys;
            if (type === 'object') {
                _keys = keys_1.default(value);
            }
            else if (type === 'array') {
                _keys = map_1.default(value, function (val, key) { return key; });
            }
            else {
                _keys = [];
            }
            for (var i = children.length - 1; i >= 0; i--) {
                var child = children[i];
                if (!contain_1.default(_keys, child.getName())) {
                    children.splice(i, 1);
                    _this.removeChild(child);
                }
            }
            if (type !== 'object' && type !== 'array') {
                return _this.collapse();
            }
            each_1.default(_keys, function (key) { return _this.addChild(key, value[key]); });
            if (recursive) {
                each_1.default(children, function (child) { return child.expand(true); });
            }
            _this.expanded = true;
            _this.$children.css('display', 'block');
            _this.$toggle.addClass(classPrefix + "collapse");
            _this.$toggle.rmClass(classPrefix + "expand");
            _this.$container.addClass(classPrefix + "expanded");
            _this.$container.rmClass(classPrefix + "collapsed");
        };
        _this.addChild = function (key, val) {
            var children = _this.children;
            var child;
            for (var i = 0, len = children.length; i < len; i++) {
                if (children[i].getName() === key) {
                    child = children[i];
                    break;
                }
            }
            if (child) {
                child.setValue(val);
            }
            else {
                var container = h_1.default('div');
                child = new JsonEditor(container, {
                    name: key,
                    value: val,
                    parent: _this,
                    nameEditable: _this.nameEditable,
                    valueEditable: _this.valueEditable,
                    enableDelete: _this.enableDelete,
                    enableInsert: _this.enableInsert,
                });
                child.once('rename', _this.onChildRename);
                child.on('delete', _this.onChildDelete);
                child.on('change', _this.onChildChange);
                children.push(child);
                _this.$children.get(0).appendChild(container);
            }
            return child;
        };
        _this.removeChild = function (child) {
            child.destroy();
        };
        _this.editName = function () {
            _this.editField('name');
        };
        _this.editValue = function () {
            _this.editField('value');
        };
        _this.editField = function (field) {
            var editable = field === 'name' ? _this.isNameEditable() : _this.isValueEditable();
            if (!editable) {
                return;
            }
            var $el = _this.$name;
            if (field === 'name') {
                _this.edittingName = true;
            }
            if (field === 'value') {
                $el = _this.$value;
                _this.edittingValue = true;
            }
            $el.addClass(classPrefix + "edit");
            $el.attr('contenteditable', 'true');
            $el.get(0).focus();
            document.execCommand('selectAll', false, undefined);
        };
        _this.editFieldStop = function (field) {
            var $el = _this.$name;
            if (field === 'name') {
                if (!_this.edittingName) {
                    return;
                }
                _this.edittingName = false;
            }
            if (field === 'value') {
                if (!_this.edittingValue) {
                    return;
                }
                $el = _this.$value;
                _this.edittingValue = false;
            }
            if (field === 'name') {
                _this.setName($el.text());
            }
            else {
                try {
                    _this.setValue(JSON.parse($el.text()));
                }
                catch (err) {
                    _this.setValue($el.text());
                }
            }
            $el.rmClass(classPrefix + "edit");
            $el.rmAttr('contenteditable');
        };
        _this.editFieldKeyPressed = function (field, e) {
            e = e.origEvent;
            switch (e.key) {
                case 'Escape':
                case 'Enter':
                    _this.editFieldStop(field);
                    break;
            }
        };
        _this.numericValueKeyDown = function (e) {
            var increment = 0;
            var currentValue;
            if (_this.type !== 'number') {
                return;
            }
            e = e.origEvent;
            switch (e.key) {
                case 'ArrowDown':
                case 'Down':
                    increment = -1;
                    break;
                case 'ArrowUp':
                case 'Up':
                    increment = 1;
                    break;
            }
            if (e.shiftKey) {
                increment *= 10;
            }
            if (e.ctrlKey || e.metaKey) {
                increment /= 10;
            }
            if (increment) {
                currentValue = parseFloat(_this.$value.text());
                if (!isNaN(currentValue)) {
                    _this.setValue(Number((currentValue + increment).toFixed(10)));
                }
            }
        };
        _this.onToggleClick = function () {
            if (_this.expanded) {
                _this.collapse();
            }
            else {
                _this.expand();
            }
        };
        _this.onInsertClick = function () {
            var newName = _this.type === 'array' ? _this.value.length : undefined;
            var child = _this.addChild(newName, null);
            if (_this.type === 'array') {
                _this.value.push(null);
                child.editValue();
            }
            else {
                child.editName();
            }
        };
        _this.onDeleteClick = function () {
            _this.emit('delete', _this);
        };
        _this.onChildRename = function (child, oldName, newName) {
            var allow = newName && _this.type !== 'array' && !has_1.default(_this.value, newName);
            if (allow) {
                _this.value[newName] = child.getValue();
                delete _this.value[oldName];
            }
            else if (oldName === undefined) {
                _this.removeChild(child);
            }
            else {
                child.setName(oldName);
            }
            child.once('rename', _this.onChildRename);
        };
        _this.onChildChange = function (keyPath, oldValue, newValue, recursed) {
            if (!recursed) {
                _this.value[keyPath] = newValue;
            }
            _this.emit('change', _this.name + '.' + keyPath, oldValue, newValue, true);
        };
        _this.onChildDelete = function (child) {
            var key = child.getName();
            if (_this.type === 'array') {
                _this.value.splice(key, 1);
            }
            else {
                delete _this.value[key];
            }
            _this.refresh();
        };
        _this.refresh = function () {
            var expandable = _this.type === 'object' || _this.type === 'array';
            each_1.default(_this.children, function (child) { return child.refresh(); });
            _this.$toggle.css('display', expandable ? 'inline-block' : 'none');
            if (_this.expanded && expandable) {
                _this.expand();
            }
            else {
                _this.collapse();
            }
        };
        var $container = _1.default(container);
        $container.addClass('luna-json-editor');
        _this.$container = $container;
        _this.appendTpl();
        _this.$toggle = $container.find("." + classPrefix + "toggle");
        _this.$name = $container.find("." + classPrefix + "name");
        _this.$separator = $container.find("." + classPrefix + "separator");
        _this.$value = $container.find("." + classPrefix + "value");
        _this.$delete = $container.find("." + classPrefix + "delete");
        _this.$children = $container.find("." + classPrefix + "children");
        _this.$insert = $container.find("." + classPrefix + "insert");
        if (!showName) {
            _this.$name.hide();
            _this.$separator.hide();
        }
        if (!enableDelete) {
            _this.$delete.hide();
        }
        if (!enableInsert) {
            _this.$insert.hide();
        }
        _this.nameEditable = nameEditable;
        _this.valueEditable = valueEditable;
        _this.parent = parent;
        _this.enableInsert = enableInsert;
        _this.enableDelete = enableDelete;
        _this.bindEvent();
        _this.setName(name);
        _this.setValue(value);
        return _this;
    }
    JsonEditor.prototype.appendTpl = function () {
        this.$container.html([
            "<div class=\"" + classPrefix + "toggle\"><span class=\"" + classPrefix + "icon " + classPrefix + "icon-arrow-right\"></span><span class=\"" + classPrefix + "icon " + classPrefix + "icon-arrow-down\"></span></div>",
            "<div class=\"" + classPrefix + "name\"></div>",
            "<div class=\"" + classPrefix + "separator\"></div>",
            "<div class=\"" + classPrefix + "value\"></div>",
            "<div class=\"" + classPrefix + "delete\"><span class=\"" + classPrefix + "icon " + classPrefix + "icon-delete\"></span></div>",
            "<div class=\"" + classPrefix + "children\"></div>",
            "<div class=\"" + classPrefix + "insert\"><span class=\"" + classPrefix + "icon " + classPrefix + "icon-add\"></span></div>",
        ].join(''));
    };
    JsonEditor.prototype.bindEvent = function () {
        this.$toggle.on('click', this.onToggleClick);
        this.$name.on('dblclick', this.editName);
        this.$name.on('blur', this.editFieldStop.bind(this, 'name'));
        this.$name.on('keypress', this.editFieldKeyPressed.bind(this, 'name'));
        this.$name.on('keydown', this.editFieldTabPressed.bind(this, 'name'));
        this.$value.on('dblclick', this.editValue);
        this.$value.on('blur', this.editFieldStop.bind(this, 'value'));
        this.$value.on('keypress', this.editFieldKeyPressed.bind(this, 'value'));
        this.$value.on('keydown', this.editFieldTabPressed.bind(this, 'value'));
        this.$value.on('keydown', this.numericValueKeyDown);
        this.$insert.on('click', this.onInsertClick);
        this.$delete.on('click', this.onDeleteClick);
    };
    JsonEditor.prototype.destroy = function () {
        var children = this.children;
        var child = children.pop();
        while (child) {
            this.removeChild(child);
            child = children.pop();
        }
        this.$container.remove();
    };
    JsonEditor.prototype.getName = function () {
        return this.name;
    };
    JsonEditor.prototype.setName = function (newName) {
        var nameType = typeof newName;
        var oldName = this.name;
        if (newName === this.name) {
            return;
        }
        if (nameType !== 'string' && nameType !== 'number') {
            throw new Error('Name must be either string or number, ' + newName);
        }
        this.$name.text(trim_1.default(toStr_1.default(newName)) === '' ? "\"" + newName + "\"" : newName);
        this.name = newName;
        this.emit('rename', this, oldName, newName);
    };
    JsonEditor.prototype.getValue = function () {
        return this.value;
    };
    JsonEditor.prototype.setValue = function (newValue) {
        var oldValue = this.value;
        var str;
        this.type = getType(newValue);
        switch (this.type) {
            case 'null':
                str = 'null';
                break;
            case 'object':
                str = 'Object';
                break;
            case 'array':
                str = 'Array(' + newValue.length + ')';
                break;
            default:
                str = newValue;
                break;
        }
        this.$value.text(str);
        this.$value.attr('class', classPrefix + "value " + (classPrefix + this.type));
        if (newValue === this.value) {
            return;
        }
        this.value = newValue;
        this.refresh();
        this.emit('change', this.name, oldValue, newValue);
    };
    JsonEditor.prototype.getType = function () {
        return this.type;
    };
    JsonEditor.prototype.isNameEditable = function () {
        if (!this.nameEditable) {
            return false;
        }
        return !(this.parent && this.parent.getType() === 'array');
    };
    JsonEditor.prototype.isValueEditable = function () {
        if (!this.valueEditable) {
            return false;
        }
        return this.type !== 'array' && this.type !== 'object';
    };
    JsonEditor.prototype.editFieldTabPressed = function (field, e) {
        e = e.origEvent;
        if (e.key === 'Tab') {
            this.editFieldStop(field);
            if (field === 'name') {
                e.preventDefault();
                this.editField('value');
            }
            else {
                this.editFieldStop(field);
            }
        }
    };
    return JsonEditor;
}((Emitter_1.default)));
function getType(value) {
    if (isNull_1.default(value)) {
        return 'null';
    }
    if (isArr_1.default(value)) {
        return 'array';
    }
    return typeof value;
}
